const tones: Record<string, string> = {
  new: 'bg-sky-100 text-sky-900',
  reviewing: 'bg-amber-100 text-amber-950',
  converted: 'bg-emerald-100 text-emerald-900',
  declined: 'bg-stone-200 text-stone-700',
  spam: 'bg-rose-100 text-rose-900',
  draft: 'bg-stone-100 text-stone-800',
  confirmed: 'bg-emerald-100 text-emerald-900',
  in_progress: 'bg-sky-100 text-sky-900',
  completed: 'bg-dome-moss/20 text-dome-forest',
  cancelled: 'bg-rose-100 text-rose-900',
  sent: 'bg-sky-100 text-sky-900',
  accepted: 'bg-emerald-100 text-emerald-900',
  expired: 'bg-stone-200 text-stone-700',
  partial: 'bg-amber-100 text-amber-950',
  paid: 'bg-emerald-100 text-emerald-900',
  void: 'bg-stone-200 text-stone-700',
};

export function StatusBadge({ status }: { status: string }) {
  const tone = tones[status] || 'bg-stone-100 text-stone-800';
  return (
    <span
      className={`inline-flex rounded-md px-2 py-0.5 text-xs font-medium capitalize ${tone}`}
    >
      {status.replace(/_/g, ' ')}
    </span>
  );
}
